<template>
  <div class="SectionBlock container">
    <div class="innerSectio-block">
        <h2 class="HeaderText">{{acf.acf.main_header}}</h2>
        <p class="headerBlockPara" v-html="acf.acf.main_text"></p>
        <p class="bookLink">Book your visit today!</p>
        <b-row class="setupSpace">
            <b-col sm="12" lg="6">
                <b-row class="marginSpace" v-for="(about, index) in acf.acf.left_column" :key="index">
                    <b-col sm="12" lg="2">
                        <img class="image" :src="about.image">
                    </b-col>
                    <b-col sm="12" lg="10">
                        <h2 class="secHeader">{{about.header}}</h2>
                        <p class="secText" v-html="about.text"></p>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" lg="6">
                <b-row class="marginSpace" v-for="(about, index) in acf.acf.right_column" :key="index">
                    <b-col sm="12" lg="2">
                        <img class="image" :src="about.image">
                    </b-col>
                    <b-col sm="12" lg="10">
                        <h2 class="secHeader">{{about.header}}</h2>
                        <p class="secText" v-html="about.text"></p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div class="outerButton">
            <b-link href="https://www.youtube.com/@ImSim/featured" target="_blank">
                <button class="FindMore">Find out more and see our Sims in action</button>
            </b-link>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Experience the Thrill',
  components: {

  },
  data: function() {
    return {
      acf: [],
      simData: []
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/25" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.simData = response.data.acf.sims
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.HeaderText {
    color: #FD021D;
    font-size: 40px;
    font-weight: 800;
    margin-top: 80px;
    margin-bottom: 40px;
}
.headerBlockPara {
    font-size: 18px;
    font-weight: 800;
}
.bookLink {
    color: #FD021D;
    font-size: 18px;
    font-weight: 800;
    margin-top: 30px;
    margin-bottom: 80px;
}
.secHeader {
    color: #FD021D;
    font-size: 30px;
    font-weight: bold;
    text-align: left;
}
p.secText {
    color: #000000;
    font-size: 18px;
    text-align: left;
}
img.image {
    width: 81px;
    height: 80px;
}
.marginSpace {
    padding-bottom: 30px;
}
button.FindMore {
    background: #FD021D;
    border: #FD021D;
    width: 674px;
    height: 65px;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 70px;
    margin-top: 60px;
}
button.FindMore:hover {
    background: #000;
    border: #000;
    width: 674px;
    height: 65px;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 70px;
    margin-top: 60px;
}



.innerSectio-block {
    color: #000;
}
img.ImageLogo.Car {
    width: 120px;
    height: auto;
    margin-top: 41px;
}
.optionAbout {
    margin: auto;
    /* margin-right: 85px */
}
.Whitetitle {
    color: #fff;
    font-size: 40px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.simulators {
    /* background-color: #1A1A1A;
    padding: 50px;
    padding-top: 90px;
    padding-bottom: 90px; */
}
.WhiteStandard-text {
    font-size: 24px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.aboutTrack-width {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 70px;
}
.borderWhite {
    border: 1px solid #FFFFFF;
}
.ImageLogo {
    height: 70px;
    width: 70px;
}
.coachingLogo {
    width: 50px;
}
.exclusive-Club {
    height: 50px;
    position: relative;
    top: 20px;
    margin-bottom: 20px;
}
.aboutBlocks {
    padding: 30px;
    height: 580px;
}
p.aboutBlock-Text {
    color: #fff;
    font-size: 20px;
    padding-top: 30px;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.triangle-right {
    width: 0;
    height: 0;
    border-top: 60px solid transparent;
    border-left: 61px solid #D80E1F;
    border-bottom: 0px solid transparent;
    transform: rotate(270deg);
    position: absolute;
    right: 16px;
    bottom: 2.1px;
}
.ImageLogoSection {
    padding-top: 40px;
    padding-bottom: 50px;
}
@media only screen and (max-width: 1366px) {
    .aboutBlocks {
        padding: 30px;
        height: 600px;
    }
}
@media only screen and (min-width: 1201px) {
    .below1200 {
        display: none;
    }
}
@media only screen and (max-width: 1200px) {
    .Whitetitle {
        color: #fff;
        font-size: 35px;
        font-family: "korolev", sans-serif;
        font-weight: 700;
        font-style: italic;
    }
    .above1200 {
        display: none;
    }
    .aboutBlocks {
        padding: 30px;
        height: 535px;
    }
    .below1200.col-lg-6 {
        margin-bottom: 30px;
    }
}
@media only screen and (max-width: 768px) {
    .outerButton {
        padding-left: 20px;
        padding-right: 20px;
    }
    button.FindMore {
        background: #FD021D;
        border: #FD021D;
        width: 100%;
        height: 65px;
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        margin-bottom: 70px;
        margin-top: 60px;
    }
    .headerBlockPara {
        font-size: 18px;
        font-weight: 800;
        padding-left: 10px;
        padding-right: 10px;
    }
    img.image {
        width: 81px;
        height: 80px;
        margin-bottom: 20px;
    }
    .secHeader {
        color: #FD021D;
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        padding-bottom: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    p.secText {
        color: #000000;
        font-size: 18px;
        text-align: center;
        padding-left: 10px;
        padding-right: 10px;
    }
    img.ImageLogo.Car {
        width: 120px;
        height: auto;
    }
    .triangle-right {
        bottom: 27.1px;
    }
    .borderWhite {
        margin-bottom: 25px;
    }
    .ImageLogoSection {
        padding: 0;
    }
    .aboutBlocks {
        padding: 30px;
        height: 500px;
    }
    .AboutTrackMan {
        padding: 25px;
    }
    .container {
        padding-left: 0;
        padding-right: 0;
    }
    .aboutTrack-width {
        width: 100%;
        text-align: center;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .optionAbout {
        margin: auto;
        margin-right: 0px
    }
    .Whitetitle {
        font-size: 36px;
        margin-top: 30px;
    }
    .WhiteStandard-text{
        font-size: 20px;
    }
}
</style>
